/* @flow */
import { AdminRoles } from 'admin/constants/AdminRoles';
import apiRequest from 'lib/apiRequest';
import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import CurrentUser from 'auth/CurrentUser';
import DialogContent from 'components/DialogContent.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import React from 'react';
import RoleVerificationStore from 'stores/RoleVerificationStore';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';
import OrganizationActions from 'actions/OrganizationActions';

export const libs = {
  apiRequest,
};

import './styles/SetupSchoolEmail.scss';

const SetupSchoolEmail = React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  getInitialState() {
    const initialEmail = CurrentUser.getUser().getEmail();
    return {
      email: initialEmail,
      showEmailInput: !initialEmail,
      enabled: false,
      submitting: false,
    };
  },

  componentDidMount() {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      window.fbq('track', 'Lead');
    }
  },

  onSuccess() {
    OrganizationActions.loadUserOrganizations();
    UserActions.loadCurrentUser().then(
      () => this.context.router.push({ pathname: '/classes', query: { admin: true } })
    );
  },

  onError(error: Object) {
    this.setState({ submitting: false });
    ToastActions.showErrorToast(error.message);
  },

  onSubmit() {
    const roleVerification = RoleVerificationStore.getRoleVerification();
    const orgId = roleVerification.organization_id;
    const officialTitle = (roleVerification.role in AdminRoles)
      ? AdminRoles[roleVerification.role]
      : roleVerification.role;

    const data = {
      official_email: this.state.email,
      official_title: officialTitle,
    };
    this.setState({ submitting: true });
    libs.apiRequest(
      `/organizations/${orgId}/users/${CurrentUser.getUser().id}/roles/admin`,
      'POST',
      data,
    ).then(this.onSuccess, this.onError);
  },

  renderEmailConfirm() {
    if (this.state.submitting) {
      return <LoadingIndicator className="SetupSchoolEmail-loader" />;
    }
    return (
      <div className="SetupSchoolEmail-emailConfirm">
        <Button
          className="SetupSchoolEmail-emailConfirm-no"
          disabled={this.state.submitting}
          onClick={() => this.setState({ showEmailInput: true })}
          eventElementName="SetupSchoolEmail-emailConfirm-no">
          No
        </Button>
        <Button
          className="SetupSchoolEmail-emailConfirm-yes"
          disabled={this.state.submitting}
          onClick={this.onSubmit}
          eventElementName="SetupSchoolEmail-emailConfirm-yes">
          Yes
        </Button>
      </div>
    );
  },

  renderEmailInput() {
    return (
      <BoxBody divided>
        <Form
          onValid={() => this.setState({ enabled: true })}
          onInvalid={() => this.setState({ enabled: false })}
          onValidSubmit={this.onSubmit}>
          <div>
            <FormInput
              label="Email address"
              name="email"
              type="email"
              validations="isEmail"
              value={this.state.email}
              onChange={event => this.setState({ email: event.target.value })}
            />
          </div>

          {this.state.submitting ?
            <LoadingIndicator className="SetupSchoolEmail-loader" /> :
            <Button
              className="SetupSchoolEmail-emailConfirm-next"
              disabled={!this.state.enabled}
              type="submit"
              level="primary"
              eventElementName="SetupSchoolEmail-emailConfirm-next">
              Next
            </Button>}
        </Form>
      </BoxBody>
    );
  },

  render() {
    const roleVerification = RoleVerificationStore.getRoleVerification();
    if (!roleVerification) {
      this.context.router.push('/setup/admin_role');
    }

    const orgType = roleVerification.is_school ? 'school' : 'district';
    const dialogTitle = this.state.showEmailInput
      ? `What is your official ${orgType} email address?`
      : `Is ${this.state.email} your official ${orgType} email address?`;

    return (
      <DialogContent
        size="small"
        className="SetupSchoolEmail"
        title={dialogTitle}
        subtext={
          'Remind verifies the status of every administrator. ' +
          `Your email address must match the one listed in your ${orgType} directory.`
        }>
        {this.state.showEmailInput ? this.renderEmailInput() : this.renderEmailConfirm()}
      </DialogContent>
    );
  },
});

export default SetupSchoolEmail;



// WEBPACK FOOTER //
// ./src/setup/components/SetupSchoolEmail.jsx